// extracted by mini-css-extract-plugin
module.exports = {"verseContainer":"EmbeddableVerseCell_verseContainer__GCj_d"};